import { render, staticRenderFns } from "./JobsAllocatedInAMonthDrillDown.vue?vue&type=template&id=9c64cb3c&"
import script from "./JobsAllocatedInAMonthDrillDown.vue?vue&type=script&lang=ts&"
export * from "./JobsAllocatedInAMonthDrillDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports